/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { RecourseTableViewDto } from '../../models/recourse-table-view-dto';
import { RequestBuilder } from '../../request-builder';
import { StrictHttpResponse } from '../../strict-http-response';

export interface GetTableViewsFromRegisteredUserByTableViewArea$Params {
  tableViewArea: string;
}

export function getTableViewsFromRegisteredUserByTableViewArea(
  http: HttpClient,
  rootUrl: string,
  params: GetTableViewsFromRegisteredUserByTableViewArea$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<Array<RecourseTableViewDto>>> {
  const rb = new RequestBuilder(rootUrl, getTableViewsFromRegisteredUserByTableViewArea.PATH, 'get');
  if (params) {
    rb.path('tableViewArea', params.tableViewArea, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<RecourseTableViewDto>>;
    }),
  );
}

getTableViewsFromRegisteredUserByTableViewArea.PATH = '/service/v1/tableView/registeredUser/{tableViewArea}';
